import PropTypes from "prop-types";
import React from "react";
import styled from "styled-components";

const Column = ({ className, children, bgColor, width, wrap, align }) => {
  return (
    <StyledColumn
      className={className ? `${className} column` : "column"}
      bgColor={bgColor}
      width={width}
      wrap={wrap ? "wrap" : "no-wrap"}
      align={align}
    >
      {children}
    </StyledColumn>
  );
};

Column.propTypes = {
  className: PropTypes.string,
  children: PropTypes.any,
  bgColor: PropTypes.string,
  width: PropTypes.string,
  wrap: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  align: PropTypes.string,
};

export default Column;

const StyledColumn = styled.div.attrs((props) => ({
  bgColor: props.bgColor || "transparent",
  width: props.wrap === "wrap" && !props.width ? "auto" : props.width || "100%",
  shrink: props.wrap === "wrap" ? 0 : 1,
  align: props.align,
}))`
  width: ${(props) => props.width};
  background-color: ${(props) => props.bgColor};
  flex-shrink: ${(props) => props.shrink};
  text-align: ${(props) => props.align};
  justify-content: ${(props) => (props.align === "right" ? "flex-end" : props.align)};
`;
